import { useEffect, useState } from 'react'
import {
  formatPercent,
  loadMyPerformanceResults,
  type PerformanceMonthlyResult,
} from '../lib/performance'
import { PerformanceV52View } from '../components/PerformanceV52View'

export function MyResults() {
  const [results, setResults] = useState<PerformanceMonthlyResult[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    let mounted = true
    loadMyPerformanceResults()
      .then((ownResults) => {
        if (!mounted) return
        setResults(ownResults)
      })
      .catch((err) => mounted && setError(err instanceof Error ? err.message : 'Não foi possível carregar seus resultados.'))
      .finally(() => mounted && setLoading(false))
    return () => { mounted = false }
  }, [])

  const current = results[0] ?? null
  const history = results

  if (loading) return <section className="workspace-content performance-page"><div className="empty-state">Carregando seus resultados...</div></section>

  return <section className="workspace-content performance-page">
    <div className="page-heading performance-heading">
      <div>
        <p className="eyebrow">COLABORADOR · MEUS RESULTADOS</p>
        <h1>Meus Resultados</h1>
        <p className="muted">Visão individual e privada da competência mais recente com dados publicados para você.</p>
      </div>
      {current && <span className="status-chip">Resultado consolidado de {current.unit_count} {current.unit_count === 1 ? 'unidade' : 'unidades'}</span>}
    </div>

    {error && <div className="notice error">{error}</div>}
    {!current && !error && <div className="empty-state">Ainda não existem resultados publicados para você na Auto Gestão.</div>}

    {current && <>
      <PerformanceV52View current={current} history={history} />

      <section className="performance-participation-detail">
        <div><p className="eyebrow">PARTICIPAÇÃO NPS</p><h2>{current.nps_responses} respostas recebidas</h2></div>
        <div><strong>{Math.ceil(current.total_attendances * current.target_nps_participation_pct / 100)}</strong><span>respostas necessárias para a meta de {formatPercent(current.target_nps_participation_pct)}</span></div>
      </section>
    </>}
  </section>
}
